import { useDesktop } from "../../hooks";
import { StyledLink } from "../../utils/button";
import ReactTooltip from "react-tooltip";
import wishlist from "../../assets/wishlist.svg";

interface Props {
  isToolTipMounted: boolean;
  content: {
    list1: string;
    title: string;
    data: string;
    list2: string;
    list3: string;
  };
}

const Tooltip = ({ isToolTipMounted, content }: Props) => {
  //for detecting if tooltip is mounted

  return (
    <div>
      {useDesktop() >= 1024 && isToolTipMounted && (
        <ReactTooltip
          className="home-tooltip-container"
          clickable={true}
          id="global"
          data-event="click"
          aria-haspopup="true"
          type="light"
          effect="solid"
          place="top"
        >
          <div className="home-tooltip-details">
            <h4>{content.title}</h4>
            <p>{content.data}</p>
            <ul>
              <li>{content.list1}</li>
              <li>{content.list2}</li>
              <li>{content.list3}</li>
            </ul>
            <div className="home-tooltip-btn-container">
              <StyledLink as="button">Go to Cart</StyledLink>
              <img
                src={wishlist}
                alt="wishlist"
                width="32"
                height="32"
              />
            </div>
          </div>
        </ReactTooltip>
      )}
    </div>
  );
};

export default Tooltip;
